import * as React from "react";
import { useState, useEffect } from 'react';
import { Label, Popup, Segment, Table } from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';

export interface ExportSimCisDocTableProps {
    output: string,
    encoding: string
}

export function ExportSimCisDocTable(props: React.PropsWithChildren<ExportSimCisDocTableProps>) {
    const [data, setData] = useState([]);
    const [badFormat, setBadFormat] = useState(true);

    async function convertDataToArray() {
        let cisData = props.output;
        try {
            let xReqId = uuid();
            let url = '/converter/cisDocToRecordsWithDescription'

            let resp = await fetch(url, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    'x-request-id': xReqId,
                    'encoding': props.encoding
                },
                body: cisData
            }).then((resp) => {
                return resp.json();
            });
            setData(resp);
            setBadFormat(false);
        } catch (ex) {
            setBadFormat(true);
        }
    };

    useEffect(() => {
        convertDataToArray();
    }, [props.output]);

    function formatValue(value) {
        if (value === null || value === undefined) {
            return ""
        }
        if (typeof value === "object") {
            // dates are serialized by jackson as strings, but be safe anyway
            if (Object.keys(value).includes("year")) {
                return value.day + "." + value.month + "." + value.year
            }
            return JSON.stringify(value)
        }
        return String(value)
    }

    function renderTable() {
        let lineNr = 0;
        return <Segment style={{ overflow: 'auto', maxWidth: '100%', maxHeight: '650px' }}>
            <Table celled striped singleLine>
                <Table.Body>
                    {data.map((line: any) => {
                        lineNr = lineNr + 1;
                        return <Table.Row key={lineNr}>
                            <Table.Cell selectable style={{ padding: '10px' }}>
                                {lineNr}
                            </Table.Cell>
                            <Table.Cell selectable style={{ padding: '10px', fontWeight: 'bold', background: '#f5f5f5' }}>
                                {line.satzart}
                            </Table.Cell>
                            {
                                line.recordDescription.map((entry: any) => {
                                    let info = entry.fieldName;
                                    let value = line.values[info];
                                    return <Popup key={info} header={info} content={entry.fieldType} trigger={
                                        <Table.Cell selectable style={{ padding: '10px' }}>
                                            {formatValue(value)}
                                        </Table.Cell>
                                    } />
                                })
                            }
                        </Table.Row>
                    })}
                </Table.Body>
            </Table>
        </Segment>
    };

    if (data === undefined || data.length === 0) {
        return <h3>LOADING</h3>
    } else {
        if (badFormat) {
            return <Label color='red'>The data is in bad format.</Label>
        } else {
            return renderTable();
        }
    }
}
